// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/take';
import { Injectable }             from '@angular/core';
import { Observable }             from 'rxjs/Observable';
import { Router, Resolve, RouterStateSnapshot,
         ActivatedRouteSnapshot } from '@angular/router';

import { ProductsService } from './products/products.service';
import { Product, Category, CategoryResponse, CategoryItems} from './products/product';
import { ControlsService } from './controls.service';
import { map, switchMap, tap, take } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Query } from './products/query';

@Injectable()
export class ProductsResolverService implements Resolve<any> {
  constructor(
    private ps: ProductsService,
    private router: Router,
    private cs: ControlsService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let id:number = +route.paramMap.get('id');
    let filter = { category: id || null, page: 1, limit:100};
    return this.ps.getProducts(filter);

    // return <any>combineLatest(
    //   this.cs.getFreeControlSubject().pipe(map(freeMod => (freeMod)? 'free': '')),
    //   this.cs.getRecentControlSubject().pipe(map(recentMod => (recentMod)? 5: 10)),
    //   (freeControl: string, recentControl: number) => {
    
    //     return {type: freeControl, category: id || null, page: 1, limit: recentControl } 
    //   }
    // ).pipe(
    //     take(1),
    //     switchMap((filter: Query )=> this.ps.getProducts(filter))
  
    //   );

 
    // return this.cs.getFreeControlSubject()
    // .pipe(
    //   take(1),
    //   map(freeMod => (freeMod)? 'free': ''),
    //   switchMap(freeControl => this.ps.getProducts({category: id, type: freeControl, page: 1, limit: 10}))

    // );
    
  }
}




// WEBPACK FOOTER //
// ./src/app/products-resolver.service.ts